import type { FaireProductEntity } from "../../entity_types/product";

export const p_bddzvedxb9: FaireProductEntity = {
  token: "p_bddzvedxb9",
  type: "product",
  name: "Daisy Rug- Lavender",
  brandToken: "b_b703e67f",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a35d43c376813a6727e82bc8941d7335382707f8ffbe3a33ee91f5f7cbe597fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4dfb5ed14514f5595c763b9789d92cecda40ab1a0012d68eb83d5f4ca06fe14f.jpeg",
    "https://cdn.faire.com/fastly/7109092304342e9fd7dc616d927df9afd6f5eb4c5cd4f298d61a1ad7d1dc02fb.jpeg",
    "https://cdn.faire.com/fastly/e99bdb25550b8dd95b6cedb7e6a1607ef29d0478137e09b4f94947276a84d05a.jpeg",
    "https://cdn.faire.com/fastly/2f107ced61f1365c95d05027d4c87c43a719ed001f36bab72d402b848aa6a973.jpeg",
    "https://cdn.faire.com/fastly/3653a89b398fd46a062901608b808fc3b3534a5ab4706fb9a1788aa151f69579.jpeg",
    "https://cdn.faire.com/fastly/964e961468e32d9244c633684c0feab80afdb0ef821ddc1e6a340edbc09e433f.jpeg",
  ],
  priceDollars: 19.4,
  description:
    'Make your cute home that much cuter by decorating your floor with these rugs!\n\nShaped like a daisy, this rug is just perfect for a small bathroom space, scattered around your bedroom, or even a nursery! Or even a wall! So many options omg\n\nRug measures 25"\n\n100% polyester with nonslip TPR bottom.\n\nCare instructions: machine or hand wash in cold water only. Do not machine dry. Never ever iron!',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:15.395Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
